import React, { useState, useMemo } from "react";
import Avatar from "../../components/common/Avatar";
import Chip from "../../components/common/Chip";
import CustomerCardContent from "./CustomerCardContent";
import Spinner from "../../components/common/Spinnner";
import { NotFound } from "../../components/common/NotFound";
import PaginationComponent from "../common/PaginationComponent";
import SkeletonCustomerMasterGrid from '../common/skeletonCustomerMasterGrid'

const CustomerMasterGrid = (props) => {
  const {
    filteredResults,
    handleEdit,
    handleDelete,
    handleView,
    loading,
    menuRights,
    moduleName,
  } = props;

  const [count, setCount] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = count;

  const currentTableData = useMemo(() => {
    if (filteredResults?.length <= pageSize) setCurrentPage(1);
    else if (currentPage > Math.ceil(filteredResults?.length / pageSize)) {
      setCurrentPage(1);
    }

    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return filteredResults?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, filteredResults, count]);

  return (
    <>
      <div className="row customer-table-row mb-4rem">
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
          {loading === true ? (
            <>
                <SkeletonCustomerMasterGrid rows={12} />
            </>
          ) : currentTableData?.length > 0 ? (
            <div className="card mt-0 customer-list-card">
            <div className="card-body">
              <div className="table-responsive customer-table-responsive">
                <table className="table table-borderless table-list customer-table-list">
                  <thead>
                    <tr>
                      <th><div>CUSTOMER</div></th>
                      <th><div>EMAIL</div></th>
                      <th><div>DISTRIBUTOR</div></th>
                      <th><div>SALES ENGINEER</div></th>
                      <th><div>COUNTRY</div></th>
                      <th><div>STATUS</div></th>
                      <th><div>ACTIONS</div></th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentTableData.map((items, index) => (
                      <tr key={items.id || index}>
                        <td
                          onClick={
                            menuRights?.canView
                              ? () => handleView(items)
                              : undefined
                          }
                          className={
                            menuRights?.canView
                              ? "clickable-cell"
                              : ""
                          }
                        >
                          <div className="customer-cell">
                            <Avatar preName={items.customerName} />
                            <h4>{items.customerName}</h4>
                          </div>
                        </td>

                        <td>
                          <h5>{items.email || "-"}</h5>
                        </td>

                        <td>
                          <h5>{items.distributorName || "-"}</h5>
                        </td>

                        <td>
                          <h5>{items.salesEngineerName || "-"}</h5>
                        </td>

                        <td>
                          <h5>{items.countryName || "-"}</h5>
                        </td>

                        <td>
                          {items.statusId === 2 ? (
                            <button className="btn inactive-btn">
                              {items.status}
                            </button>
                          ) : (
                            <button className="btn active-btn">
                              {items.status}
                            </button>
                          )}
                        </td>

                        <td>
                          {(menuRights?.canEdit ||
                            menuRights?.canDelete) && (
                            <div className="dropdown dropleft action-menu">
                              <span
                                className="action-icon"
                                data-toggle="dropdown"
                              >
                                <i className="fas fa-ellipsis-v"></i>
                              </span>

                              <div className="dropdown-menu p-0">
                                <ul>
                                  {menuRights?.canEdit && (
                                    <li>
                                      <span
                                        onClick={() =>
                                          handleEdit(items)
                                        }
                                      >
                                        <i className="far fa-edit mr-1"></i>
                                        Edit
                                      </span>
                                    </li>
                                  )}

                                  {menuRights?.canDelete && (
                                    <li>
                                      <span
                                        onClick={() =>
                                          handleDelete(items)
                                        }
                                      >
                                        <i className="far fa-trash-alt mr-1"></i>
                                        Delete
                                      </span>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          ) : (
            <NotFound />
          )}
        </div>
      </div>
      {currentTableData.length > 0 && (
        <PaginationComponent
          count={count}
          setCount={setCount}
          pageSize={pageSize}
          currentPage={currentPage}
          filteredResults={filteredResults}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  );
};

export default CustomerMasterGrid;
